import type { HubPresencePublishedSnapshot } from "./hubPresenceHttpUpdate";

/**
 * Tab-scoped presence HTTP state. Survives React Strict Mode remount so a hard
 * refresh does not POST /api/hub/presence/update twice.
 */

let lastPublished: HubPresencePublishedSnapshot | null = null;
let bootPostInFlight: Promise<void> | null = null;

export function getHubPresenceTabLastPublished(): HubPresencePublishedSnapshot | null {
  return lastPublished;
}

export function setHubPresenceTabLastPublished(next: HubPresencePublishedSnapshot): void {
  lastPublished = next;
}

export function resetHubPresenceTabSessionOnLogout(): void {
  lastPublished = null;
  bootPostInFlight = null;
}

export function resetHubPresenceTabSessionForTests(): void {
  lastPublished = null;
  bootPostInFlight = null;
}

/** Share the first presence POST for this tab until it settles. */
export async function runHubPresenceTabBootPost(run: () => Promise<void>): Promise<void> {
  if (lastPublished != null) {
    return;
  }
  if (bootPostInFlight != null) {
    await bootPostInFlight;
    return;
  }
  bootPostInFlight = (async () => {
    try {
      await run();
    } finally {
      bootPostInFlight = null;
    }
  })();
  await bootPostInFlight;
}
